export default __webpack_public_path__ + "dist/media/Delete.d94f31cb.svg";